(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PersonIbqDeleteController',PersonIbqDeleteController);

    PersonIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Person'];

    function PersonIbqDeleteController($uibModalInstance, entity, Person) {
        var vm = this;

        vm.person = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Person.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
